import { useEffect, useState } from "react";
import api from "../lib/api";
import { useLang } from "../contexts/LangContext";
import { Bell, Trophy, Wallet, ShieldCheck, Users, Gift, CheckCheck } from "lucide-react";
import { Button } from "../components/ui/button";

const ICON_MAP = {
  win: Trophy, wallet: Wallet, kyc: ShieldCheck,
  pool: Users, referral: Gift, welcome: Bell, admin: Bell, info: Bell,
};

export default function Notifications() {
  const { t } = useLang();
  const [items, setItems] = useState([]);
  const [unread, setUnread] = useState(0);

  const load = () => api.get("/notifications").then((r) => { setItems(r.data.items); setUnread(r.data.unread); });
  useEffect(() => { load(); }, []);

  const readAll = async () => { await api.post("/notifications/read-all"); load(); };
  const readOne = async (id) => { await api.post(`/notifications/${id}/read`); load(); };

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-8">
      <div className="flex items-center justify-between mb-8">
        <h1 className="text-3xl sm:text-4xl font-bold text-cyan-gradient flex items-center gap-3">
          <Bell className="w-7 h-7" /> {t("notifications")}
          {unread > 0 && <span className="text-sm px-2 py-1 rounded-full bg-[#00E5FF] text-[#050E1A]">{unread}</span>}
        </h1>
        {unread > 0 && <Button onClick={readAll} variant="outline" size="sm" className="border-[#1A2D4D] text-white" data-testid="mark-all-read-btn"><CheckCheck className="w-4 h-4 me-1.5" /> {t("markAllRead")}</Button>}
      </div>
      <div className="space-y-3">
        {items.map((n) => {
          const Icon = ICON_MAP[n.kind] || Bell;
          return (
            <div key={n.notification_id} onClick={() => !n.read && readOne(n.notification_id)}
                 className={`bento-card p-4 flex items-start gap-3 cursor-pointer ${!n.read ? "border-[#00E5FF]/40" : ""}`}
                 data-testid={`notif-${n.notification_id}`}>
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${!n.read ? "bg-[#00E5FF]/15" : "bg-[#1A2D4D]"}`}>
                <Icon className={`w-5 h-5 ${!n.read ? "text-[#00E5FF]" : "text-[#8FA3BD]"}`} />
              </div>
              <div className="flex-1">
                <div className="font-medium text-sm flex items-center gap-2">
                  {n.title} {!n.read && <span className="w-2 h-2 rounded-full bg-[#00E5FF]" />}
                </div>
                <div className="text-xs text-[#8FA3BD] mt-1">{n.body}</div>
                <div className="text-[10px] text-[#4A5970] mt-1.5">{new Date(n.created_at).toLocaleString()}</div>
              </div>
            </div>
          );
        })}
        {items.length === 0 && <div className="text-center text-[#8FA3BD] py-12">{t("noNotifications")}</div>}
      </div>
    </div>
  );
}
